import axios from '../../http.service';
import cloneDeep from 'lodash/cloneDeep';
import * as types from '../Enums/Contract.Teams.Enums';
import { ADD_TOAST_MESSAGE } from '../Enums/Contracts.Globals.Enums';
import { isInPast } from '../../utils';
import { getEditStatus, getLockedRows, getEditStatuses, getEditableTeams } from '../../Features/ContractManagement/Markers/edit-released-teams';
import store from '../../store';
import fields from 'Features/ContractManagement/Generic/Appointments/Components/Updater/Field.constants';

export const getContractTeamCount = (appointmentTypes, year) => {
	return async dispatch => {
		try {
			let resp = await axios.get(`/api/v2/contracts/teams/count/${year}/${JSON.stringify(appointmentTypes)}`);

			return dispatch({
				type: types.CONTRACT_TEAM_COUNT,
				payload: resp.data
			});
		} catch (error) {
			dispatch({
				type: ADD_TOAST_MESSAGE,
				payload: {
					severity: 'error',
					message: `Error while fetching Team Count Data ${error.message}`
				}
			});
			dispatch({
				type: types.CONTRACT_TEAMS_ERROR,
				payload: {
					data: [],
					errors: ['Error while fetching Team Count Data', error.message]
				}
			});
		}
	};
};

const amendmentsForTeams = async (teams, dispatch) => {
	try {
		const teamsEditStatuses = await Promise.all(teams.map(getEditStatus));
		const lockedReleasedTeams = getLockedRows(teamsEditStatuses);
		const editStatuses = getEditStatuses(teamsEditStatuses);
		const editableReleasedTeams = getEditableTeams(editStatuses);

		return dispatch({
			type: types.CONTRACT_TEAM_AMENDMENTS,
			payload: {
				lockedReleasedTeams,
				editableReleasedTeams,
				editStatuses,
				errors: []
			}
		});
	} catch (error) {
		dispatch({ type: ADD_TOAST_MESSAGE, payload: { severity: 'error', message: `Error getting editability of released Teams: ${error.message}` } });
		return dispatch({
			type: types.CONTRACT_TEAM_AMENDMENTS,
			payload: {
				lockedReleasedTeams: [],
				editableReleasedTeams: [],
				editStatuses: {},
				errors: ['Unable to check editability of marking method and marking template on released Teams', error.message]
			}
		});
	}
};

export const getContractTeams = (contractTypes, year, query, updated = [], exportData = false, teamIds = [], isRefine = false, templateId = [], contractStatus = [], markingMethod = [], title = '', markingTeamCode = '', isGroupUpdater = false, previewUpdate = [], isGroupUpdaterFilter = false) => {
	return async dispatch => {
		try {			
			let selectedTypes = [], selectedTeamIds = [];
			let previewReadyForApproval =  null, previewMarkingMethod = null, previewTemplateName = null, previewTemplateId = null, previewContractReleaseDate = null, previewContractEndDate = null, previewEmailAddress = null;
			if (previewUpdate && previewUpdate.length > 0) {
				const { readyForApproval = null, markingMethod = null, templateName = null, id = null, contractReleaseDate = null, contractEndDate = null, emailAddress = null } = previewUpdate[0];
				previewReadyForApproval = readyForApproval;
				previewMarkingMethod = markingMethod;
				previewTemplateName = templateName;
				previewTemplateId = id; 
				previewContractReleaseDate = contractReleaseDate; 
				previewContractEndDate = contractEndDate;				
				previewEmailAddress = previewUpdate[0].emailAddress;
			}
			if(isGroupUpdaterFilter) {
				const teams = store.getState().teams;			
				selectedTypes = teams.selectedTypes;
				selectedTeamIds = teams.selectedTeamIds;
				contractTypes = teams.groupUpdaterTypes;
				teamIds = teams.groupUpdaterTeamIds;
			}
			else {
				selectedTypes = contractTypes;
				selectedTeamIds = teamIds;
			}
			
			let teamPaginationData, dataCopy, dataExport;
			const resp = await axios.get(`/api/v2/contracts/teams/${year}/${JSON.stringify(contractTypes)}?pagination=${JSON.stringify(query)}`
			,{headers: {'teamIds': `${teamIds}`, 'templateId': `${templateId}`, 'contractStatus': `${contractStatus}`, 'markingMethod': `${markingMethod}` 
			, 'title': `${title}`, 'markingTeamCode': `${markingTeamCode}` }} );
			const { errors = [] } = resp.data;
			const { data = [], total = 0 } = resp.data.data[0];
			const initialDates = {
				contractReleaseDate: null,
				contractEndDate: null
			};			
			if (!exportData) {	
				teamPaginationData = data.map(o => ({
					...initialDates,
					...o,
					id_type: `${o.markingTeamId}_${o.type}`,
					selectTeam: 'N',
					hidStatus: o.displayStatus,
					hidMarkingMethod: o.markingMethodCurrentYear,
					hidTemplateId: o.templateId,
					hidTemplateName: o.templateName,
					hidReleaseDate: o.contractReleaseDate,
					hidEndDate: o.contractEndDate,
					hidEmailAddress: o.emailAddress,
					readyForApproval: o.displayStatus,	//_Group Updater columns.
					markingMethod: o.markingMethodCurrentYear,
					template: o.templateName,
					contract: {
						releaseDate: (o.contractReleaseDate || initialDates.contractReleaseDate),
						endDate: (o.contractEndDate || initialDates.contractEndDate)
					},
					teamEmail: o.emailAddress,	//_Group Updater columns.
					displayStatus: previewReadyForApproval ? previewReadyForApproval : o.displayStatus,
                    markingMethodCurrentYear: previewMarkingMethod ? previewMarkingMethod : o.markingMethodCurrentYear,
					templateName: previewTemplateName ? (previewTemplateName + ' ' + previewTemplateId) : o.templateName, 
                    contractReleaseDate: previewContractReleaseDate ? previewContractReleaseDate : (o.contractReleaseDate || initialDates.contractReleaseDate),
                    contractEndDate: previewContractEndDate ? previewContractEndDate : (o.contractEndDate || initialDates.contractEndDate),
					emailAddress: previewEmailAddress ? previewEmailAddress : o.emailAddress						
				}));
				dataCopy = cloneDeep(teamPaginationData);
				teamPaginationData = teamPaginationData.map(o => {
					const matchData = updated.find(x => x.id_type === o.id_type);
					return { ...o, ...matchData };
				});

				if(previewUpdate.length == 0) {
					const teamsReleased = teamPaginationData.filter(team => isInPast(team.contractReleaseDate));
					amendmentsForTeams(teamsReleased, dispatch);
				}
			}
			else
			{
				//_Modified for making it generic for group updater component.
				dataExport = data.map(o => ({					
					...initialDates,
					...o,
					id_type: `${o.markingTeamId}_${o.type}`,
					template: o.templateName,
					readyForApproval: o.displayStatus,
					teamEmail: o.emailAddress,
					contract: {
						releaseDate: o.contractReleaseDate || initialDates.contractReleaseDate,
						endDate: o.contractEndDate || initialDates.contractEndDate
					},
					markingMethod: o.markingMethodCurrentYear,
					isSave: false
				}));
			}

			if (isRefine) {
				return dispatch({ type: types.CONTRACT_TEAM_GET_REFINE, payload: { refineData: dataExport, errors } });
			}
			else if (isGroupUpdater) {
				return dispatch({ type: types.CONTRACT_TEAM_GET_GROUP_UPDATER, payload: { groupUpdaterData: dataExport, errors } });
			}
			else {
				let payload = {
					data: !exportData ? teamPaginationData : dataExport,
					dataCopy,
					total,
					errors,
					selectedTypes,
					selectedTeamIds,
					selectedTemplateId: templateId || [],
					selectedContractStatus: contractStatus || [],
					selectedMarkingMethod: markingMethod || [],
					inputTitle: title || '',
					inputMarkingTeamCode: markingTeamCode || ''
				};
				return dispatch({
					type: !exportData ? types.CONTRACT_TEAM_GET : types.CONTRACT_TEAM_GET_ALL,
					payload
				});
			}			
		} catch (error) {
			dispatch({
				type: ADD_TOAST_MESSAGE,
				payload: {
					severity: 'error',
					message: `Error while fetching Team Data ${error.message}`
				}
			});
			dispatch({
				type: types.CONTRACT_TEAMS_ERROR,
				payload: {
					errors: []
				}
			});
		}
	};
};

export const addUpdateToTeam = (field, newValue, row, updated = []) => {	
	//Fixed issue of updating templateId. 
	if (field == 'templateName') {		
		row.templateId = newValue;
		//_Get template Data from redux store.
		const templateData = store.getState().teams.templateData;
		const item = templateData && templateData.find(x => parseInt(x.value) === parseInt(newValue));
		if(item) {
			row.templateName = item.label;
		}		
	}
	
	return dispatch => {
		let _updated;
		if (updated.filter(x => x.id_type === row.id_type).length > 0) {
			_updated = updated.map(x => {
				return x.id_type !== row.id_type ? x : { ...x, [field]: newValue };
			});
		} else {
			_updated = [...updated, row];
		}

		dispatch({
			type: types.CONTRACT_TEAM_ADD_UPDATE,
			payload: {
				updated: _updated,
				errors: []
			}
		});
	};
};

export const applyMultiTeamUpdate = (data, updated, multiTeamData) => {
	return dispatch => {
		const _data = data.map(item => {
			if (item.displayStatus === 'Issued') {
				return { ...item, selectTeam: 'N' };
			}

			if (item.selectTeam === 'Y') {
				return { ...item, ...multiTeamData, selectTeam: 'N' };
			}
			return item;
		});

		const _updated = updated
			.filter(item => item.displayStatus !== 'Issued')
			.map(item => {
				if (item.selectTeam === 'Y') {
					return { ...item, ...multiTeamData, selectTeam: 'N' };
				}
				return item;
			});

		dispatch({
			type: types.CONTRACT_TEAM_APPLY_MULTI_EDIT,
			payload: {
				data: _data,
				updated: _updated,
				errors: []
			}
		});
	};
};

export const removeUpdate = (keyField, id, updated = []) => {
	return dispatch => {
		const _updated = updated.filter(update => update[keyField] !== id);
		dispatch({
			type: types.CONTRACT_TEAM_ADD_UPDATE,
			payload: {
				updated: _updated,
				errors: []
			}
		});
	};
};

export const removeAllEdits = () => {
	return (dispatch, getState) => {
		const {
			teams: { dataCopy }
		} = getState();
		const data = cloneDeep(dataCopy);
		dispatch({
			type: types.CONTRACT_TEAM_REMOVE_ALL_EDITS,
			payload: {
				data
			}
		});
	};
};

export const clearAllTeamsUpdates = () => dispatch => dispatch({ type: types.CONTRACT_TEAM_CLEAR_ALL_UPDATES, payload: {} });

export const saveUpdatedContractTeams = (year, updated) => {
	return async (dispatch, getState) => {
		try {
			//_Below given columns are excluded from updates array and passed only required columns.
			let updatesWithRequiredColumns = updated.map(
				({
					id_type,
					selectTeam,
					title,
					markingTeamCode,
					templateName,
					contractTypeName,
					hidStatus,
					setDisplayStatus,
					hidMarkingMethod,
					hidTemplateId,
					hidTemplateName,
					hidReleaseDate,
					hidEndDate,
					hidEmailAddress,
					isSave,
					contract,
					markingMethod,
					readyForApproval,
					teamEmail,
					template,
					...item
				}) => item
			);	

			const response = await axios.put(`/api/v2/contracts/teams/${year}`, {
				updates: updatesWithRequiredColumns
			});

			//_Get table/Page Data from redux store.
			const { data, groupUpdaterData } = getState().teams;			
			const errorDetails = response.data.errors || []	
			const errors = errorDetails.map(x => x.error) || [];
			if (errors.length == 0) {
				data.forEach(item => {
					const updatedItem = updated.find(x => x.id_type === item.id_type);
					if (updatedItem) {
						item.hidStatus = updatedItem.displayStatus;
						item.hidMarkingMethod = updatedItem.markingMethodCurrentYear;
						item.hidTemplateId = updatedItem.templateId;
						item.hidTemplateName = updatedItem.templateName;
						item.hidReleaseDate = updatedItem.contractReleaseDate;
						item.hidEndDate = updatedItem.contractEndDate;
						item.hidEmailAddress = updatedItem.emailAddress;
					}
				});
				groupUpdaterData.forEach(item => item.isSave = true);
			}
			else {
				const failed_data = errorDetails.map(item => ({ markingTeamId: item.markingTeamId, type: item.type })) || [];
				const tempUpdated = updated.map(item => ({ markingTeamId: item.markingTeamId, type: item.type })) || [];
				const partial_save_data = tempUpdated.filter(x => !failed_data.some(y => (x.markingTeamId == y.markingTeamId && x.type == y.type))) || [];	

				data.forEach(item => {
					const updatedItem = partial_save_data.find(x => (x.markingTeamId == item.markingTeamId && x.type == item.type));
					if (updatedItem) {
						item.hidStatus = item.displayStatus;
						item.hidMarkingMethod = item.markingMethodCurrentYear;
						item.hidTemplateId = item.templateId;
						item.hidTemplateName = item.templateName;
						item.hidReleaseDate = item.contractReleaseDate;
						item.hidEndDate = item.contractEndDate;
						item.hidEmailAddress = item.emailAddress;
						item.readyForApproval = item.displayStatus;
						item.markingMethod = item.markingMethodCurrentYear;
						item.template = item.templateName;
						item.contract = {
							releaseDate: item.contractReleaseDate,
							endDate: item.contractEndDate
						};
						item.teamEmail = item.emailAddress;
					}
					else 
					{
						item.displayStatus = item.hidStatus;
						item.markingMethodCurrentYear = item.hidMarkingMethod;
						item.templateId = item.hidTemplateId;
						item.templateName = item.hidTemplateName;
						item.contractReleaseDate = item.hidReleaseDate;
						item.contractEndDate = item.hidEndDate;
						item.emailAddress = item.hidEmailAddress;
					}
				});

				if(partial_save_data.length > 0){
					groupUpdaterData.forEach(item => {
						const updatedItem = partial_save_data.find(x => (x.markingTeamId == item.markingTeamId && x.type == item.type));
						if (updatedItem) {
							item.isSave = true;
						}
					});
				}
			}

			const dataCopy = cloneDeep(data);
						
			let hasErrors = errors.length > 0;
			let message = hasErrors ? 'Error while Updating Contract Teams' : 'Successfully Saved Contract Teams Updates';

			let payload = {
				errors,
				message,
				data,
				dataCopy,
				groupUpdaterData
			};
			dispatch({
				type: ADD_TOAST_MESSAGE,
				payload: { severity: hasErrors ? 'error' : 'success', message }
			});
			return dispatch({
				type: types.CONTRACT_TEAM_SAVE,
				payload
			});
		} catch (error) {
			let { message, response: { data = {} } = {} } = error;
			dispatch({
				type: ADD_TOAST_MESSAGE,
				payload: {
					severity: 'error',
					message: `Error while saving updates: ${message} - ${Object.values(data).join(', ')}`
				}
			});
			return dispatch({
				type: types.CONTRACT_TEAMS_ERROR,
				payload: {
					errors: []
				}
			});
		}
	};
};

export const addTeamsError = (error = '') => {
	return dispatch => {
		return dispatch({
			type: types.CONTRACT_TEAMS_ERROR,
			payload: { message: 'An Error Occured', errors: [error] }
		});
	};
};

export const clearUpdateTeamErrors = () => {
	return dispatch =>
		dispatch({
			type: types.CONTRACT_TEAM_CLEAR,
			payload: { message: '', errors: [] }
		});
};

export const getContractTeamsTemplate = appointeeType => {
	let payload = { data: [{ value: '', label: '' }], errors: [], message: '' };
	return async dispatch => {
		try {
			let resp = await axios.get(`/api/v2/contracts/teams/template/${appointeeType}`);

			if (Object.keys(resp.data).length > 0 && typeof resp.data.data === 'undefined')
				payload = {
					data: [{ value: '', label: '' }],
					errors: typeof resp.data.errors !== 'undefined' ? resp.data.errors : [],
					message: typeof resp.data.message !== 'undefined' ? resp.data.message : ''
				};
			else if (Object.keys(resp.data).length > 0 && typeof resp.data.data !== 'undefined')
				payload = {
					data: resp.data.data.map(team => {
						return { value: team.id, label: team.name + ' ' + team.id, name: team.name };
					}),
					errors: resp.data.errors,
					message: typeof resp.data.message !== 'undefined' ? resp.data.message : ''
				};

			return dispatch({ type: types.CONTRACT_TEAM_TEMPLATE_GET, payload });
		} catch (error) {
			dispatch({
				type: ADD_TOAST_MESSAGE,
				payload: {
					severity: 'error',
					message: `Error while fetching Team Data ${error.message}`
				}
			});
			dispatch({
				type: types.CONTRACT_TEAMS_ERROR,
				payload: {
					data: [],
					errors: [],
					message: ''
				}
			});
		}
	};
};

export const clearRefineData = () => dispatch => dispatch({ type: types.CONTRACT_TEAM_REFINE_CLEAR, payload: {} });

export const getGroupUpdaterUpdates = () => {
	return dispatch => {
		const groupUpdaterData = store.getState().teams.groupUpdaterData || [];	
		dispatch({ type: types.CONTRACT_TEAM_GROUP_UPDATER_UPDATES, payload: { groupUpdaterData } });
	};
};

export const setGroupUpdaterResultsDetails = (isGroupUpdaterFilter = false, groupUpdaterTypes = [], groupUpdaterTeamIds = []) => {
	return dispatch => {
		dispatch({
			type: types.CONTRACT_TEAM_GROUP_UPDATER_FILTER,
			payload: { isGroupUpdaterFilter, groupUpdaterTypes, groupUpdaterTeamIds }
		});
	};
};

export const clearGroupUpdaterData = () => dispatch => dispatch({ type: types.CONTRACT_TEAM_GROUP_UPDATER_CLEAR, payload: {} });

export const clearRefineFilters = () => dispatch => dispatch({ type: types.CONTRACT_TEAM_GROUP_UPDATER_CLEAR, payload: {} });